export const getDisplayTime = (time: string) => {
  const timeStrings = time.split(':');
  let hh = timeStrings[0];
  const mm = timeStrings[1];
  let amPm = '上午';
  const hour = Number(hh);
  if (hour >= 12) {
    amPm = '下午';
    hh = hour - 12 < 10 ? `0${hour - 12}` : `${hour - 12}`;
  }

  return {
    amPm,
    hh,
    mm,
  };
};
